export default __webpack_public_path__ + "static/media/modern-groteseque-times-ko.b811ba56.png";